// 聊天相关接口
import request from './request'

// REST API 接口封装
export const chatApi = {
  // 1. 发送消息（离线消息）
  sendMessage: (data) =>
    request({
      url: '/api/chat/sendMessage',
      method: 'post',
      data
    }),

  // 2. 获取当前用户的所有聊天会话
  getSessions: (params) =>
    request({
      url: '/api/chat/sessions',
      method: 'get',
      params
    }),

  // 3. 获取聊天消息列表
  getMessages: (params) =>
    request({
      url: '/api/chat/messages',
      method: 'get',
      params
    }),

  // 4. 标记消息为已读
  markAsRead: (sessionId) =>
    request({
      url: '/api/chat/markAsRead?sessionId=' + sessionId,
      method: 'post',
      data: {
        sessionId
      }
    }),

  // 5. 获取或创建与指定用户的聊天会话
  getOrCreateSession: (data) =>
    request({
      url: '/api/chat/getOrCreateSession',
      method: 'post',
      data
    }),

  // 6. 获取在线企业用户列表
  getOnlineBusinessUsers: () =>
    request({
      url: '/api/chat/onlineBusinessUsers',
      method: 'get'
    }),

  // 7. 检查用户在线状态
  checkOnlineStatus: (params) =>
    request({
      url: '/api/chat/checkOnlineStatus',
      method: 'get',
      params
    }),

  // 8. 获取未读消息总数
  getUnreadCount: (params) =>
    request({
      url: '/api/chat/unreadCount',
      method: 'get',
      params
    })
}

// WebSocket 工具函数（辅助创建和管理WebSocket连接）
export const websocketUtil = {
  // 创建WebSocket连接
  /*   createWebSocket: (userId, userType) => {
      return new WebSocket(`ws://test.business.yuugeai.com/api/chat/${userId}/${userType}`);
    }, */
  createWebSocket: (userId, userType) => {
    const isDev = process.env.NODE_ENV === 'development';
    if (isDev) {
      // 开发环境使用本地WebSocket服务器
      return new WebSocket(`ws://localhost:8080/ws/${userId}/${userType}`);
    } else {
      // 生产环境使用远程WebSocket服务器
      const host = window.location.host;
      return new WebSocket(`wss://${host}/ws/${userId}/${userType}`);
    }
  },

  // 发送心跳消息
  sendHeartbeat: (websocket) => {
    if (websocket && websocket.readyState === WebSocket.OPEN) {
      websocket.send(JSON.stringify({ type: 'heartbeat' }));
    }
  },

  // 发送实时聊天消息
  sendChatMessage: (websocket, data) => {
    if (websocket && websocket.readyState === WebSocket.OPEN) {
      websocket.send(JSON.stringify({
        type: 'chat',
        ...data
      }));
    }
  },

  // 标记消息已读（WebSocket方式）
  markAsRead: (websocket, data) => {
    if (websocket && websocket.readyState === WebSocket.OPEN) {
      websocket.send(JSON.stringify({
        type: 'read',
        ...data
      }));
    }
  },

  // 启动心跳定时器
  startHeartbeatTimer: (websocket, interval = 30000) => {
    return setInterval(() => {
      websocketUtil.sendHeartbeat(websocket);
    }, interval);
  }
}